import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { SharedService } from 'src/app/utils/shared.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';

import * as CommonConstants from '../../utils/common.constants';
import { NumericEditor } from 'src/app/common/grid-utils/numeric-editor.component';
import { AgGridColumn } from 'ag-grid-angular';
@Component({
  selector: 'app-add-treatment',
  templateUrl: './add-treatment.component.html'
})
export class AddTreatmentComponent implements AfterViewInit {

  medicationGridApi: GridApi;
  medicationGridColumnApi;
  medicationtList = [];
  medicationRowData = [];
  @Input() medFileId;
  status;
  frameworkComponents;
  PARAM_KEY = [CommonConstants.ROUTE, CommonConstants.PRESENTATION, CommonConstants.DOSAGE, CommonConstants.STATUS];
  MED_PARAM_KEY = [CommonConstants.TREATMENT_MED_FILE]
  masterValues = [];
  routes;
  presentations;
  dosages;
  //add medication 
  medicationDefs;
  constructor(private modal: NgbModal, private masterService: MasterService,
    private medFileService: MedicalFileService, private toastrService: ToastrService, private sharedService: SharedService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent,
      agNumeric:NumericEditor
    }

  }

  ngOnInit() {
    this.loadMaster();
    this.loadMedication();
    /*  this.sharedService.medicalFileId$.subscribe(res=>{
       this.medfiId = res;
     }) */
  }

  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.routes = this.masterValues.filter(master => master.paramKey === CommonConstants.ROUTE);
        this.presentations = this.masterValues.filter(master => master.paramKey === CommonConstants.PRESENTATION);
        this.dosages = this.masterValues.filter(master => master.paramKey === CommonConstants.DOSAGE);
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });
  }

  loadMedication() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
      this.medFileService.getMedicalFilesByKey(this.medFileId, this.MED_PARAM_KEY).subscribe(response => {
        let masterValues = response['result'];
        if (masterValues) {
          this.medicationtList = this.setMedicationList(masterValues[CommonConstants.TREATMENT_MED_FILE]);
        }
      })
    })
  }

  ngAfterViewInit() {
  }

  defaultColDef = {
    editable: true,
    singleClickEdit: true,
    resizable: true,
    sortable:true,
    filter:true,
  }

  onGridReadyMedication(params) {
    this.medicationGridApi = params.api;
    this.medicationGridApi.sizeColumnsToFit();
   // this.medicationGridColumnApi = params.columnApi;
   // this.sharedService.autoSizeAll(this.medicationGridColumnApi);
  }

  addNewMedicationModal(modalId) {
    this.medicationRowData = [];
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.medicationDefs) {
      this.getMedicationGrids();
    }
  }

  addNewMedication() {
    const newRow = {
      statuCode: '', medmeDtDate: '', medmeVaDescription: '', route: '', medmeNuQtyPerDay: '', medmeNuQtyPerTake: '', preseCode: '',
      dosagCode: '', medmeNuRythmPerHours: '', medmeDtStart: '', medmeNuDurationPerDay: '', endDmedmeDtEndate: '', medmeVaAdvice: '',
      description: ''
    };
    this.medicationRowData.unshift(newRow);
    this.medicationGridApi.setRowData(this.medicationRowData);
  }

  getMedicationGrids() {
    this.medicationDefs = [
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      { headerName: 'Date', field: 'medmeDtDate', cellEditor: 'agDateInput' },
      { headerName: 'Description', field: 'medmeVaDescription' },
      { headerName: 'routeCode', field: 'routeCode', hide: true },
      {
        headerName: 'Route', field: 'route', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.routes, dataColumn: 'routeCode', model: new Parameter(), objectData: ['id', 'value'] }
      }, ,
      { headerName: 'QtyDay', field: 'medmeNuQtyPerDay',cellEditor: 'agNumeric',valueSetter: this.sharedService.newPublishSetter },
      { headerName: 'QtyTake', field: 'medmeNuQtyPerTake' ,cellEditor: 'agNumeric'},
      { headerName: 'preseCode', field: 'preseCode', hide: true },
      {
        headerName: 'Presentation', field: 'presentation', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.presentations, dataColumn: 'preseCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'dosagCode', field: 'dosagCode', hide: true },
      {
        headerName: 'Dosage', field: 'dosage', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.dosages, dataColumn: 'dosagCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'Rythm', field: 'medmeNuRythmPerHours' ,cellEditor: 'agNumeric'},
      { headerName: 'StartDate', field: 'medmeDtStart', cellEditor: 'agDateInput' },
      { headerName: 'Duration', field: 'medmeNuDurationPerDay', cellEditor: 'agNumeric'},
      { headerName: 'EndDate', field: 'medmeDtEnd', cellEditor: 'agDateInput' },
      { headerName: 'Advice', field: 'medmeVaAdvice' },
      {
        headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
    ];
   
  }

  saveMedication() {
    this.medicationRowData = this.medicationRowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.medFileService.saveMedication(this.medicationRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        let mapMasters = this.setMedicationList(res["result"]);
        if(mapMasters)
          this.medicationtList.push(this.setMedicationList(mapMasters[0]));
        this.medicationtList = Object.values(this.medicationtList.reduce((acc, c) => (acc[c.medmeId] = c, acc), {}));
        this.medicationtList = [...this.medicationtList];
        this.modal.dismissAll();
      }
    })
  }

  onMedicationRowSelect(modelId) {
    this.getMedicationGrids();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.medicationRowData = this.medicationtList;
  }

  setMedicationList(list) {
    if (list) {
      if (Array.isArray(list)) {
        list = list.map(item => ({
          ...item,
          route: item.routeCode ? this.routes.find(obj => +obj.id === +item.routeCode).value : null,
          dosage: item.dosagCode ? this.dosages.find(obj => +obj.id === +item.dosagCode).value : null,
          presentation: item.preseCode ? this.presentations.find(obj => +obj.id === +item.preseCode).value : null,
          status: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
        }));
      } else {
        list = {
          ...list,
          route: list['routeCode'] ? this.routes.find(obj => +obj.id === +list['routeCode']).value : null,
          dosage: list['dosagCode'] ? this.status.find(obj => +obj.id === +list['dosagCode']).value : null,
          presentation: list['preseCode '] ? this.presentations.find(obj => +obj.id === +list['preseCode']).value : null,
          status: list['statuCode'] ? this.status.find(obj => +obj.id === +list['statuCode']).value : null,
        }
      }
      return list;
    }
  }

}
